var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2289 8.61126V10.1919C11.2301 10.4887 11.1061 10.7721 10.8875 10.9727C10.6688 11.1733 10.3758 11.2724 10.0802 11.2457C8.45892 11.0695 6.90152 10.5155 5.53318 9.62816C4.26012 8.81921 3.18079 7.73988 2.37184 6.46682C1.48138 5.09227 0.927229 3.52729 0.75428 1.89867C0.727658 1.60407 0.826081 1.31185 1.02551 1.09338C1.22493 0.87492 1.50699 0.75033 1.80279 0.750052H3.38347C3.91239 0.744846 4.36322 1.13256 4.43725 1.6563C4.50396 2.16215 4.62769 2.65883 4.80607 3.13687C4.95083 3.52196 4.85824 3.95608 4.56897 4.24861L3.89982 4.91776C4.64988 6.23685 5.74207 7.32905 7.06116 8.0791L7.73032 7.40995C8.02284 7.12068 8.45696 7.0281 8.84206 7.17285C9.32009 7.35123 9.81677 7.47496 10.3226 7.54168C10.8524 7.61642 11.2421 8.07636 11.2289 8.61126Z",
    stroke: "#141E30",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneSmall);
export default __webpack_public_path__ + "static/media/phone-small.e812c445.svg";
export { ForwardRef as ReactComponent };